import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { productPath } from '../seo/site';

const Footer = ({ content, products = [] }) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="copyright">{content.copyright}</p>
        <div className="footer-links">
          {products.map((product) => (
            <Link key={product.id} to={productPath(product.id)} className="footer-link">
              {product.title}
            </Link>
          ))}
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms" className="footer-link">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
